import { payloadExtractor } from 'app-webtech-core/reducers/payloadExtractor';
import { updateState } from 'app-webtech-core/reducers/updateState';
import { CCSETTINGSMENU } from 'app-webtech-core/modules/player/constants';
import { getName } from '../actions/helpers/ccMenuIndexHelper';

const stateMutationGenerator = () => ({
  isCCMenuOpen: { $set: false },
  ccMenuSelectedIndexes: { $set: [] },
  currentCCMenu: { $set: CCSETTINGSMENU },
  currentCCMenuName: { $set: getName(CCSETTINGSMENU[0]) },
});
export const playerCCMenuResetReducer = (currentState, action) =>
  updateState(currentState, stateMutationGenerator(payloadExtractor(action)));
